export enum JourneyType {
  RETURN = 'return',
  ONEWAY = 'oneway',
  COMPLEX = 'complex',
}
